import { useEffect, useRef } from 'react'
import { AccessibilityInfo } from 'react-native'

type FieldMeta = {
  error?: string
  submitFailed?: boolean
}

export function useAnnounceError(meta: FieldMeta) {
  const lastAnnouncedErrorRef = useRef<string | undefined>(undefined)

  useEffect(() => {
    if (!meta.error) {
      lastAnnouncedErrorRef.current = undefined
      return
    }

    if (!meta.submitFailed || meta.error === lastAnnouncedErrorRef.current) {
      return
    }

    const errorToAnnounce = meta.error
    const timeoutId = setTimeout(() => {
      AccessibilityInfo.announceForAccessibility(errorToAnnounce)
      lastAnnouncedErrorRef.current = errorToAnnounce
    }, 100)

    return () => {
      clearTimeout(timeoutId)
    }
  }, [meta.error, meta.submitFailed])
}
